import React from 'react';
import { Link } from 'react-router-dom';
import { pwaTrueEmptySotHref } from './createPwaJob';
import { PWA_JOBS_PATH, pwaJobsSotHref } from './ordersSurface';

type Props = {
    active?: string | null;
};

const TrueEmptySwitcher = ({ active = null }: Props) => (
    <nav className="jobs-sot-switcher" data-testid="true-empty-switcher" aria-label="True-empty create walk">
        <Link
            className={`jobs-sot-link${active === 'walk' ? ' is-active' : ''}`}
            to={pwaTrueEmptySotHref('walk')}
        >
            TRUE EMPTY · WALK
        </Link>
        <Link className="jobs-sot-link" to={pwaJobsSotHref('empty')}>
            CREATE · SOT
        </Link>
        <Link className="jobs-sot-link" to={PWA_JOBS_PATH}>
            Exit walk
        </Link>
    </nav>
);

export default TrueEmptySwitcher;
